import { requestPermissionsAsync } from 'expo-notifications/build/NotificationPermissions';
import { fromPromise } from 'xstate';

import type { RequestPushNotificationPermissionOutput } from '../../permissions.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const requestPushNotificationPermissionActor =
  fromPromise<RequestPushNotificationPermissionOutput>(async () => requestPermissionsAsync());
